export const BudgetItemColors = {
  monthlyIncome: undefined,
  housing: '#0062B9',
  food: '#00B2F6',
  transportation: '#8EC638',
  insuranceAndTaxes: '#F6A200',
  utilities: '#EA3921',
  householdItems: '#581845',
  debt: '#1200DD',
  retirement: '#8B008B',
  personalEntertainment: '#B300D0',
  savings: '#006990',
  giving: '#52741F',
  other: '#AC3400',
};

export const BudgetItemLabels = {
  monthlyIncome: 'Monthly Income (after taxes)',
  housing: 'Housing',
  food: 'Food',
  transportation: 'Transportation',
  insuranceAndTaxes: 'Insurance',
  utilities: 'Utilities',
  householdItems: 'Household Items',
  personalEntertainment: 'Personal and Entertainment',
  retirement: 'Retirement',
  debt: 'Debt',
  savings: 'Savings',
  giving: 'Giving',
  other: 'Other',
};

/* eslint-disable */
export const BudgetItemToolTipText = {
  monthlyIncome: undefined,
  housing: 'Aim for 25% (or less) of your monthly take-home pay for this and your homeowners/renters insurance.',
  food: 'This is what you usually spend on groceries and restaurants.',
  transportation: 'Think gas, auto insurance, maintenance, etc.',
  insuranceAndTaxes:
    'Add the policies you didn\'t budget for yet: term life, health, long-term disability, long-term care (age 60+), identity theft, and umbrella (with a net worth of $500,000 or more).',
  utilities:
    'Think electricity, water, natural gas, your basic phone plan, etc.',
  householdItems: 'Don\'t forget laundry care, toothpaste, soap and such. (Please.)',
  personalEntertainment: 'Add in what you spend on fun activities, personal care, streaming services, etc.',
  debt: 'This is any money you owe: credit cards, car payments, student loans, etc.',
  retirement: 'Once you\'re debt-free with a fully funded emergency fund, plan to invest 15% of your monthly take-home pay.',
  savings:
    'If you have debt, get $1,000 in savings—then focus on paying off the debt.',
  giving: 'Start your budget right by giving 10% of your income.',
  other: 'Whatever you spend money on that didn\'t fit above, plop it in here.',
};
/* eslint-enable */
